import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
let AccountDetails = class AccountDetails extends Vue {
    get infos() {
        return [
            {
                label: 'First Name',
                value: this.firstName,
            },
            {
                label: 'Last Name',
                value: this.lastName,
            },
            {
                label: 'Mobile Number',
                value: `${this.dialCode}${this.contactNumber}`,
            },
            {
                label: 'Birthdate',
                value: this.birthdate,
            },
            {
                label: 'Email',
                value: this.email,
            },
            {
                label: 'Business Email',
                value: this.businessEmail,
            },
        ];
    }
};
__decorate([
    Prop({ type: String, required: true })
], AccountDetails.prototype, "firstName", void 0);
__decorate([
    Prop({ type: String, required: true })
], AccountDetails.prototype, "lastName", void 0);
__decorate([
    Prop({ type: String, required: true })
], AccountDetails.prototype, "contactNumber", void 0);
__decorate([
    Prop({ type: String, required: true })
], AccountDetails.prototype, "dialCode", void 0);
__decorate([
    Prop({ type: String, required: true })
], AccountDetails.prototype, "birthdate", void 0);
__decorate([
    Prop({ type: String, required: true })
], AccountDetails.prototype, "email", void 0);
__decorate([
    Prop({ type: String, required: true })
], AccountDetails.prototype, "businessEmail", void 0);
AccountDetails = __decorate([
    Component
], AccountDetails);
export default AccountDetails;
